<template>
  <div class="login-wrap">
    <div class="logo">
      <!-- <el-image style="width: 83px; height: 34px" src="https://www.magaoedu.com/img_new/logo.png"></el-image> -->
    </div>
    <div class="form-wrapper">
      <div class="header">码高问道平台</div>
      <div class="input-wrapper">
        <div class="border-wrapper">
          <input type="text" name="username" v-model="account" @keydown.enter="login" placeholder="请输入学籍号或手机号"
            class="border-item" autocomplete="off" />
        </div>
        <div class="border-wrapper">
          <input type="password" name="password" v-model="password" @keydown.enter="login" placeholder="请输入密码"
            class="border-item" autocomplete="off" />
        </div>
      </div>
      <div class="action">
        <div class="btn" @click="login">登录</div>
      </div>
      <div class="action">
        <div class="btnR" @click="openRegister">注册账号</div>
      </div>
    </div>
    <div class="footer_text">
      <el-link href="https://www.magaoedu.com/" target="_blank"  type="primary">官网</el-link>
      <el-link  href="http://www.kjtcsw.com/" target="_blank" type="primary">科技特长生网</el-link>
    </div>
    <el-dialog title="选择账号" :modal="false" center :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialogVisible" width="400px">
      <div class="select-students">
        <el-select v-model="form.id" class="select-child" placeholder="请选择" style="width: 300px">
          <el-option v-for="item in students" :key="item.id" :label="item.studentName" :value="item.id"> </el-option>
        </el-select>
        <el-input type="password" v-model="form.studentsPassword" @keydown.native="keyFn" style="width: 300px"
          class="select-child" placeholder="请输入密码"></el-input>
        <el-button type="primary" round style="margin-top: 40px" @click="studentLogin">确定并登录</el-button>
      </div>
    </el-dialog>

    <el-dialog title="注册账号" center :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="registerVisible" width="440px">
      <div class="select-students">
        <div>
          <label>手机号</label>
          <el-input placeholder="请输入手机号" style="width:200px;margin-left: 5px;"
            v-model.number="ruleForm.phone"></el-input>
          <el-button type="primary" style="margin-left: 10px;width: 115px;" @click="getPhoneCode">{{ codeText
            }}</el-button>
        </div>
        <div>
          <el-input placeholder="请输入验证码" style="width:200px;margin-left:-80px;margin-top:10px"
            v-model.number="ruleForm.code"></el-input>

        </div>
        <div>
          <el-input placeholder="来源必填" style="width:200px;margin-left: -80px;margin-top:10px;"
            v-model.number="ruleForm.source"></el-input>
          <br />
          <b style="color: red;margin-left: -127px;font-size: 12px;">从哪了解到的码高问道平台</b>
        </div>

        <el-button type="primary" @click="submitForm('ruleForm')"
          style="margin-left: -70px;margin-top:10px">注册</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "login",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      setTimeout(() => {
        console.log(value, value.toString().length);
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else if (value.toString().length !== 11) {
          callback(new Error("请输入正确手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      codeFlag: true,
      codeText: '获取验证码',
      submiting: false,
      form: {
        id: "",
        studentsPassword: "",
      },
      ruleForm: {
        phone: "",
        code: '',
        source: '',
      },
      rules: {
        phone: [{ validator: checkPhone, trigger: "blur" }],
      },
      phoneCode: '',
      students: [],
      dialogVisible: false,
      registerVisible: false,
      redirect: "", // 重定向:重新指向其它path,会改变网址
      account: "",
      password: "",
    };
  },
  methods: {
    getPhoneCode() {
      if (!this.codeFlag) return;
      if (!this.ruleForm.phone) return this.$notify.error("请输入手机号")
      let count = 60;
      let setInter = null;
      this.codeFlag = false;
      this.errtext = "";
      setInter = setInterval(() => {
        if (count > 0) {
          count--;
          this.codeText = count + "秒";
        } else {
          count = 60;
          this.codeFlag = true;
          this.codeText = "重新获取";
          clearInterval(setInter);
          setInter = null;
        }
      }, 1000);
      this.$axios
        .post(
          this.$API.getWebsitePhoneCode,
          this.$todo.formData({
            phoneNumber: this.ruleForm.phone
          })
        )
    },
    openRegister() {
      this.registerVisible = true;
    },
    async submitForm(formName) {
      this.submiting = true;
      if (!this.ruleForm.phone) {
        return this.$notify.error("请输入手机号");
      }
      if (!this.ruleForm.code) {
        return this.$notify.error("请输入验证码");
      }
      let checkRusult = await this.$axios.post(this.$API.checkPhoneCode, this.$todo.formData({
        phoneNumber: this.ruleForm.phone,
        phoneCode: this.ruleForm.code
      }));
      if (checkRusult.data == 1) {
        if (!this.ruleForm.source) {
          return this.$notify.error("请输入从哪里了解到码高问道平台的");
        }
        let postData = {
          schoolName: "网校国内",
          phone: this.ruleForm.phone,
          sourceType: 85,
          sourceUri: window.location.href,
          cardName: this.ruleForm.phone,
          remark:this.ruleForm.source
        };
        this.$axios.post(this.$API.saveWangXiaoStudent, this.$todo.formData(postData)).then((res) => {
          if (res.status == 200) {
            if (res.msg == "提交成功") {
              this.submiting = false;
              this.registerVisible = false;
              this.$confirm("<p>账号注册成功！您的密码是：123456 <br> <span>点击确定自动登录</span> </p>", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true,
                type: "success",
              })
                .then(() => {
                  this.account = this.ruleForm.phone;
                  this.password = "123456";
                  this.login();
                })
                .catch(() => {
                  console.log("点击取消");
                });
            } else {
              this.showRegisterResult(res.msg);
            }
          } else if (res.status == 500) {
            this.submiting = false;
            this.registerVisible = false;
            this.$confirm("<p>该手机号已存在，可直接登录。密码：123456 <br> <span>点击确定自动登录</span> </p>", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              dangerouslyUseHTMLString: true,
              type: "warning",
            })
              .then(() => {
                this.account = this.ruleForm.phone;
                this.password = "123456";
                this.login();
              })
              .catch(() => {
                console.log("点击取消");
              });
          } else {
            this.showRegisterResult("注册失败, 请重新提交！");
          }
        });
      } else {
        return this.$notify.error("验证码失败");

      }

    },

    showRegisterResult(msg) {
      this.submiting = false;
      this.$notify.error({
        message: msg,
      });
    },
    keyFn(e) {
      if (e.keyCode == 13) {
        this.studentLogin();
      }
    },
    studentLogin() {
      if (this.form.id == "") {
        return this.$notify.error("请选择账号");
      }
      if (this.form.studentsPassword == "") {
        return this.$notify.error("请输入密码");
      }
      this.$axios
        .post(
          this.$API.rlogin,
          this.$todo.formData({
            id: this.form.id,
            password: this.form.studentsPassword,
          })
        )
        .then((res) => {
          if (res.data.status == "200") {
            let result = res;
            this.$notify({
              message: "登录成功",
              type: "success",
              offset: 45,
              showClose: false,
              duration: 800,
            });
            if (result.data.userName == "") {
              result.data.userName = this.ruleForm.phone;
            }
            this.$todo.setCookie("token", result.data.token, result.data.token_expires);
            this.$store.commit("setToken", result.data.token);
            this.$todo.setLocal("loginInfo", result.data);
            this.$store.commit("updateToken", true);
            this.$router.push({ path: "/" });
          } else {
            this.$notify.error({
              message: "账号密码错误！",
            });
          }
        });
    },
    login: _.debounce(async function () {
      let { account, password } = this;
      if (account == "" || password == "") {
        return this.$notify.error({
          message: "请输入账号密码！",
        });
      }
      const loading = this.$loading({
        lock: true,
        text: "登录中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let result = await this.$axios.post(
        this.$API.login,
        this.$todo.formData({
          account,
          password,
        })
      );
      if (result) {
        if (result.data.status == 500) {
          this.$notify.error({
            message: "账号密码错误！",
          });
          loading.close();
        } else {
          if (result.data.relatives == "1") {
            this.students = result.data.students;
            this.dialogVisible = true;
            loading.close();
          } else {
            this.$notify({
              message: "登录成功",
              type: "success",
              offset: 45,
              showClose: false,
              duration: 800,
            });
            if (result.data.userName == "") {
              result.data.userName = this.ruleForm.phone;
            }
            this.$todo.setCookie("token", result.data.token, result.data.token_expires);
            this.$store.commit("setToken", result.data.token);
            this.$todo.setLocal("loginInfo", result.data);
            this.$store.commit("updateToken", true);
            // this.$router.push({ path: this.redirect || '/' },);
            this.$router.push({ path: "/" });
            loading.close();
          }
        }
      } else {
        loading.close();
      }
    }, 500),
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        const path = route.path;
        if (query) {
          this.redirect = query.redirect;
        }
        if (path && path != "/login") {
          this.redirect = path;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style>
.select-child {
  margin-top: 10px;
}
</style>

<style scoped>
.footer_text{
  position: absolute;
  bottom: 20px;
  left: 56px;
}
.footer_text a{
  margin: 0 10px;
}
.select-students {
  text-align: center;
}

.login-wrap {
  width: 100%;
  height: 100vh;
  font-family: JetBrains Mono Medium;
  display: flex;
  flex-flow: column;
  align-items: left;
  justify-content: center;
  background: url("https://file.magaoedu.com/c1cefba0644d1921fd4937d6204f7e44.png");
  background-size: 100% 100%;
}

.login-wrap .logo {
  position: absolute;
  top: 20px;
  left: 20px;
}

.form-wrapper {
  width: 400px;
  color: #fff;
  border-radius: 2px;
  padding: 0px 50px 100px 50px;
}

.form-wrapper .header {
  text-align: center;
  font-size: 40px;
  text-transform: uppercase;
  line-height: 140px;
  color: rgb(16, 19, 186);
  font-weight: bold;
}

.form-wrapper .input-wrapper input {
  /* background-color: rgb(41, 45, 62); */
  border: 0;
  width: 100%;
  /* text-align: center; */
  text-indent: 1em;
  font-size: 15px;
  color: #000;
  outline: none;
}

.form-wrapper .input-wrapper input::placeholder {
  text-transform: uppercase;
}

.form-wrapper .input-wrapper .border-wrapper {
  background-image: linear-gradient(to right, #e8198b, #409eff);
  width: 100%;
  height: 50px;
  margin-bottom: 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-wrapper .input-wrapper .border-wrapper .border-item {
  height: calc(100% - 4px);
  width: calc(100% - 4px);
  border-radius: 10px;
  border-bottom: 1px solid #bbb;
}

.form-wrapper .action {
  display: flex;
  justify-content: center;
}

.form-wrapper .action .btn {
  width: 100%;
  margin-top: 40px;
  text-transform: uppercase;
  text-align: center;
  line-height: 50px;
  border-radius: 10px;
  background-image: linear-gradient(120deg, #43cbff, #9708cc);
  cursor: pointer;
}

.form-wrapper .action .btnR {
  width: 100%;
  margin-top: 10px;
  text-transform: uppercase;
  text-align: center;
  line-height: 50px;
  border-radius: 10px;
  background-image: linear-gradient(120deg, #43cbff, #9708cc);
  cursor: pointer;
}

.form-wrapper .icon-wrapper {
  text-align: center;
  width: 60%;
  margin: 0 auto;
  margin-top: 20px;
  border-top: 1px dashed rgb(146, 146, 146);
  padding: 20px;
}

.form-wrapper .icon-wrapper i {
  font-size: 20px;
  color: rgb(187, 187, 187);
  cursor: pointer;
  border: 1px solid #fff;
  padding: 5px;
  border-radius: 20px;
}

.form-wrapper .icon-wrapper i:hover {
  background-color: #0e92b3;
}
</style>
